import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'

import styles from './styles.scss'

import { 
    projectSelectedSelector
} from 'containers/Form/Project/selectors'


const mapStateToProps = (state) => {
    return {
      projectSelected: projectSelectedSelector(state)
    }
  }

const ErrorPage = ({ projectSelected : { value }}) =>
    <Fragment>
        <p>There was an error when importing from Project #{value}. Please try again.</p>
    </Fragment>

const withConnect = connect(mapStateToProps, null)
const styledComponent = CSSModules(ErrorPage, styles)
export default withConnect(styledComponent)
